import { useSubscribeLink } from "@helper/checkMobileAppLink";
import { ENABLE_NEW_HEADER_FOOTER } from "@helper/getEnvVariables";
import { List, ListItem } from "@sphtech/sph-web-ui/elements/List";
import cx from "classnames";
import React from "react";

import { FooterMenuDetails } from "./footerMenuConstants";
import { FooterMenuType } from "./footerMenuType";

type FooterMenuListProps = {
  testId: string;
  items: FooterMenuDetails[];
  type: FooterMenuType;
};

export function FooterMenuList({ testId, items, type }: FooterMenuListProps) {
  const subLink = useSubscribeLink();

  const listStyle = cx(
    "text-text-inverse",
    type === "social" &&
      (ENABLE_NEW_HEADER_FOOTER
        ? "flex items-center lg:-mt-[10px]"
        : "flex items-center gap-xxs mt-1"),
    type === "top" &&
      (ENABLE_NEW_HEADER_FOOTER
        ? "[&_a]:font-regular"
        : "mt-sm [&_a]:font-semimedium"),
    type === "eshop" && "[&_a]:font-semibold",
    type === "appDownload" &&
      (ENABLE_NEW_HEADER_FOOTER ? "flex gap-[12px]" : "flex mt-xs gap-[12px]"),
  );

  return (
    <List testId={`${testId}-${type}-footerMenuList`} className={listStyle}>
      {items.map((item: FooterMenuDetails, index: number) => (
        <React.Fragment key={index}>
          {!(subLink === "" && item.title === "Langgan") && (
            <>
              <ListItem
                key={`${testId}-item-${index}`}
                testId={`${testId}-item-${index}`}
              >
                <a
                  key={index}
                  href={item.url}
                  target={item.newTab ? "_blank" : "_self"}
                  rel="noopener noreferrer"
                  className={cx(
                    "text-xs font-primary text-text-inverse lead-[150%] font-thin hover:underline",
                    type === "social" &&
                      index === 4 &&
                      "p-1.5 flex justify-end",
                  )}
                >
                  {item.title ? item.title : null}
                  {item.images ? (
                    <img src={item.images} alt={`${item.title}-menu-icon`} />
                  ) : null}
                </a>
              </ListItem>
            </>
          )}
        </React.Fragment>
      ))}
    </List>
  );
}
